/*
* @Author: babysoft08
* @Date:   2025-06-07 16:11:17
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-06-24 17:20:15
*/
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import DropZone from './../../components/DropZone/DropZone';
import './QualityControl.css';
import { Link } from 'react-router-dom';
import CategoryService from './../../services/CategoryService/CategoryService';
import QualityControlService from './../../services/QualityControlService/QualityControlService';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import Loader from './../../components/Loader/Loader';
import { Validation } from '../../validation';

const renderHTML = (rawHTML) => React.createElement("div", { className: "text-center", dangerouslySetInnerHTML: { __html: rawHTML } });

const PREVIEW_COUNT = 100;

class QualityControl extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			allPartNumbers: [],
			filteredPartNumbers: [],
			files: [],
			fileErrors: [],
			uploadedFiles: [],
			fields: [],
			errors: [],
			selected_part_number: null,
			is_loader: 1,
			isSubmit: 0,
			isShowSuccessModal: false,
			apiMessage: null
		}
		this.categoryService = new CategoryService();
		this.qualityControlService = new QualityControlService();
		this.renderSelect = this.renderSelect.bind(this);
		this.getPartNumbers();
	}

	getPartNumbers() {
		this.categoryService.getAvailablePartNumbers().then((response) => {
			if (response.status === 200) {
				const partNumbers = response.data.partNumbers.map((partNumber) => ({
					value: partNumber,
					label: partNumber,
				}));
				this.setState({ allPartNumbers: partNumbers, is_loader: 0 });
				this.setState({ filteredPartNumbers: partNumbers.slice(0, PREVIEW_COUNT) })
			}
		})
	}

	renderSelect() {
		const { allPartNumbers, selected_part_number, errors } = this.state;
		return (
			<React.Fragment>
				<Select
					className="custom-select-container"
					classNamePrefix="custom-select"
					options={allPartNumbers}
					value={selected_part_number}
					onChange={(selected) => {
						this.setState({ selected_part_number: selected });
					}}
					placeholder="Select a motor part number"
					isClearable
				/>
				{errors.selected_part_number && (
					<div className="text-danger mt-1">{errors.selected_part_number}</div>
				)}
			</React.Fragment>
		)
	}

	renderFileError() {
		let { fileErrors } = this.state;
		return (
			<React.Fragment>
				{(fileErrors.length > 0) &&
					(
						<React.Fragment>
							<div className="alert alert-danger mt-2" role="alert">
								<ul>
									{fileErrors.map((value, index) => (
										<li key={index}>{value}</li>
									))}
								</ul>
							</div>
						</React.Fragment>
					)
				}
			</React.Fragment>
		)
	}

	renderDropZone() {
		let { files, fileErrors, isDisabled } = this.state;
		return (
			<React.Fragment>
				<div className="col-md-12">
					<h4 className="dark-color1 text-center">File Upload</h4>
					<DropZone files={files} setFiles={this.handleFileUpload} fileErrors={fileErrors} setFileErrors={this.handleFileError} />
					<h4 className="dark-color1 text-center pt-3"> File List </h4>
					{this.renderFileError()}
					<ul className="file-list-div">
						{files.map((file, index) => (
							<li key={index}>
								{this.getFileIcon(file.name)}&nbsp; {file.name}
							</li>
						))}
					</ul>
				</div>
			</React.Fragment>
		)
	}

	handleChange(field, e) {
		let { fields } = this.state;
		const { name, value } = e.target;
		const newFormData = {
			...fields,
			[name]: value,
		};
		this.setState({ fields: newFormData });
	}

	handleSubmit(e) {
		e.preventDefault();
		const { fields, selected_part_number } = this.state;

		let errors = Validation(fields, ['company_name', 'contact_email', 'description']);

		if (!selected_part_number) {
			errors.selected_part_number = "Motor part number is required";
		}

		if (Object.keys(errors).length > 0) {
			this.setState({ errors });
			return;
		}

		this.setState({ errors: {} });
		this.submitForm(e);
	}

	submitForm(e) {
		e.preventDefault();
		window.scrollTo({ top: 0, behavior: 'smooth' });
		const { fields, files, selected_part_number } = this.state;
		const formData = {
			...fields,
			motor_part_number: selected_part_number ? selected_part_number.value : '',
			files: files,
		};
		console.log(formData)
		this.setState({ isSubmit: 1 });
		this.qualityControlService.saveData(formData).then((response) => {
			if (response.data.status === 'success') {
				this.setState({
					apiMessage: `<h1>Quality Issue Submitted</h1><p>Thank You! Your issue has been submitted to our Quality Team.</p><p>You will receive communication on this Ticket via email within 24 hrs.</p><p>Ticket #${response.data.result.ticket_number}</p>`,
					isShowSuccessModal: true
				});
				this.resetForm();
			}

		});
	}

	resetForm() {
		this.setState({
			files: [],
			fileErrors: [],
			uploadedFiles: [],
			fields: {
				company_name: '',
				contact_email: '',
				motor_application: '',
				description: ''
			},
			errors: [],
			selected_part_number: null,
			isSubmit: 0
		});
	}

	handleFileUpload = (files) => {
		this.setState({ files });
		this.setState({ isDisabled: (files.length > 0) ? false : true });
	};

	handleFileError = (errors) => {
		this.setState({ fileErrors: errors });
	}

	getFileIcon = (fileName) => {
		const ext = fileName.split(".").pop().toLowerCase();

		switch (ext) {
			case "pdf":
				return <span className="file-icon pdf">📄</span>;
			case "xlsx":
			case "xls":
				return <span className="file-icon excel">📊</span>;
			case "jpg":
			case "jpeg":
			case "png":
			case "tiff":
			case "tif":
				return <span className="file-icon image">🖼️</span>;
			default:
				return <span className="file-icon default">📁</span>;
		}
	};

	renderForm() {
		const { errors } = this.state;
		return (
			<React.Fragment>
				<form className="techtop-report-quality-issue-form" onSubmit={this.handleSubmit.bind(this)}>
					<div className="mb-3">
						<label htmlFor="company_name" className="form-label">Company Name</label>
						<input type="text" className="form-control" id="company_name" name="company_name" ref="company_name" onChange={this.handleChange.bind(this, 'company_name')} value={this.state.fields['company_name'] || ''} />
						{errors.company_name && <div className="text-danger">{errors.company_name}</div>}
					</div>
					<div className="mb-3">
						<label htmlFor="contact_email" className="form-label">Contact Email Address</label>
						<input type="email" className="form-control" id="contact_email" name="contact_email" ref="contact_email" onChange={this.handleChange.bind(this, 'contact_email')} value={this.state.fields['contact_email'] || ''} />
						{errors.contact_email && <div className="text-danger">{errors.contact_email}</div>}
					</div>
					<div className="mb-3">
						<label htmlFor="part" className="form-label">Motor Part Number</label>
						{this.renderSelect()}
					</div>
					<div className="mb-3">
						<label htmlFor="motor_application" className="form-label">Motor Application</label>
						<input type="text" id="motor_application" className="form-control" name="motor_application" ref="motor_application" onChange={this.handleChange.bind(this, 'motor_application')} value={this.state.fields['motor_application'] || ''} />
					</div>
					<div className="mb-3">
						<label htmlFor="description" className="form-label">Description</label>
						<textarea className="form-control" id="description" name="description" ref="description" onChange={this.handleChange.bind(this, 'description')} value={this.state.fields['description'] || ''}></textarea>
						{errors.description && <div className="text-danger">{errors.description}</div>}
					</div>
					<div className="mb-3">
						<label htmlFor="attachments" className="form-label">Upload Attachments (images or documents)</label>
						{this.renderDropZone()}
					</div>
					<button type="submit" className="btn submit-btn">Submit</button>
				</form>
			</React.Fragment>
		)
	}

	renderSuccessModal() {
		let { isShowSuccessModal, apiMessage } = this.state;
		return (
			<React.Fragment>
				{isShowSuccessModal && (
					<React.Fragment>
						<div className="motor-modal-overlay">
							<div className="motor-modal-content">
								{apiMessage && renderHTML(apiMessage)}
								<div className="d-flex w-100 justify-content-evenly gap-4">
									<button type="button" className="btn btn-secondary w-50 m-0 rounded" onClick={() => this.setState({ isShowSuccessModal: false })}> Close </button>
								</div>
							</div>
						</div>
					</React.Fragment>
				)}
			</React.Fragment>
		)
	}

	render() {
		let { is_loader, isSubmit } = this.state;
		return (
			<React.Fragment>
				<main className="techtop-middle-div">
					{this.renderSuccessModal()}
					<section className="techtop-report-quality-issue-section">
						<div className="container">
							<div className="row">
								<div className="col-md-8 offset-md-2">
									<div className="card">
										<div className="row" id="report-quality-issue-form">
											<div className="col-md-12 mt-3">
												<h2>Report Quality Issue</h2>
												{(is_loader) ? <GearSpinner /> : this.renderForm()}
											</div>
										</div>
										<div className="form-footer-link text-center mt-2">
											<p className="m-0"><a href="/quality-control-status">Already submitted? Check your ticket status</a></p>
											<p className="m-0"><a href="/qcontrol">QC Team Login</a></p>
										</div>

									</div>
								</div>
							</div>
						</div>
					</section>
					<Loader isLoading={isSubmit} message="Processing..." />
				</main>
			</React.Fragment>

		)
	}
}

export default QualityControl;